import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { ReactNode } from 'react';

type Props = {
    body: ReactNode;
    className?: string;
    header: ReactNode;
    /** Add walkthrough DOM node */
    walkthroughStep?: string;
};

export const DescriptionSection = ({ body, className, header, walkthroughStep }: Props) => {
    return (
        <div className={cn('relative flex flex-col gap-xs', className)}>
            <H5>{typeof header === 'string' ? <FormattedMessage id={header} /> : header}</H5>
            <BodyPrimary
                className="whitespace-pre-wrap"
                color="secondary"
            >
                {body}
            </BodyPrimary>
            {walkthroughStep && (
                <span
                    className="absolute left-sm w-0"
                    data-testid={`walkthrough-step-${walkthroughStep}`}
                    data-walkthrough-step={walkthroughStep}
                />
            )}
        </div>
    );
};
